import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { log } from 'console';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CasetaService } from 'src/app/services/caseta.service';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { CorteService } from 'src/app/services/corte.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';

@Component({
  selector: 'app-eludidos',
  templateUrl: './eludidos.component.html',
  styleUrls: ['./eludidos.component.scss']
})
export class EludidosComponent implements OnInit {

  openTab = 1;
  casetas:any[];
  user: any;
  reporteForm:FormGroup
  constructor(
    private corteService: CorteService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store<AppState>,
    private fb: FormBuilder,
    private reporteriaServices:ReporteriaService) {

    this.reporteForm = this.fb.group({
      caseta: new FormControl("", Validators.required),
      fecha: new FormControl(moment(new Date()).format('YYYY-MM-DD'), Validators.required),
      tipo:new FormControl(1, Validators.required)
    })
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start();
    this.store.select(selectUser).subscribe(user =>{
      this.user = user;
      this.reporteForm.setValue({  caseta:this.user.caseta_usuario[0].id, fecha:moment(new Date()).format('YYYY-MM-DD'), tipo:1})
    });
    this.corteService.getCasetas().subscribe( casetas => {
      this.casetas = casetas;
      this.ngxUiLoaderService.stop();
    });

  }
  setTipoReporte(val){
    this.openTab=val;
    this.reporteForm.patchValue({tipo:val,
      caseta:this.user.caseta_usuario[0].id,})
  }
  generarReporte(){
    let urlExcel:string;
    let {tipo, fecha}=this.reporteForm.value
    this.ngxUiLoaderService.start();
    let nombreArchivo=(tipo==1?"ReporteDiarioEludidoTipo_":"ReporteMensualEludidoTipo_")+(tipo==1?moment(fecha).format('DD-MM-YYYY'):moment(fecha).format('MM-YYYY'))
    this.reporteriaServices.reportesEludidos(this.reporteForm.value).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo+'.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    this.ngxUiLoaderService.stop();

    });

  }
  bitton(){
  this.reporteriaServices.example().subscribe(blob => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'plantilla.xlsx';
  a.click();
  URL.revokeObjectURL(url);
});

  }

}
